import { createFileRoute } from "@tanstack/react-router";
import DePrivacy from "@/pages/legal/DePrivacy";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/privacy/")({
  head: () => routeHead("/de/privacy/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DePrivacy />
  );
}
